function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHouseBlue = function SvgHouseBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_15",
    "data-name": "Layer 15",
    viewBox: "0 0 500 500",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    style: {
      fill: "#456E89"
    },
    d: "M148,228.77H342.81a10.25,10.25,0,0,0,0-20.49H148a10.25,10.25,0,0,0,0,20.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    style: {
      fill: "#456E89"
    },
    d: "M209.55,198h71.73a10.25,10.25,0,0,0,0-20.49H209.55a10.25,10.25,0,0,0,0,20.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    style: {
      fill: "#456E89"
    },
    d: "M476.08,424.69h-41V404.2a10.25,10.25,0,0,0-10.25-10.26h-20.6V193.81l39.61,15.73a10.27,10.27,0,0,0,14-9.53V155.3a10.28,10.28,0,0,0-6.1-9.37l-61-27.09V65.89a10.26,10.26,0,0,0-10.24-10.25H335.87a10.25,10.25,0,0,0-10.25,10.25v24l-75-33.34a10.25,10.25,0,0,0-8.3,0L41.1,145.93A10.27,10.27,0,0,0,35,155.3V200a10.24,10.24,0,0,0,10.24,10.25,10.13,10.13,0,0,0,3.32-.54l40.09-13.65V393.94H66a10.25,10.25,0,0,0-10.27,10.24h0v20.49H25a10.26,10.26,0,0,0-.67,20.5H476.08a10.26,10.26,0,0,0,0-20.5Zm-130-348.55h24.2v33.23l-19.17-8.16-5-2.21ZM55.52,162,246.45,77.11l83.65,37.17a9.81,9.81,0,0,0,1.76,1L343,120l94.41,42v22.94L397.77,169.2l-.48-.18L249.76,118.79a10.27,10.27,0,0,0-6.79.06L95.52,172.08l-40,13.62Zm53.65,27,137.38-49.61L383.73,186V393.94H264.28V307.4a68.37,68.37,0,0,0-136.74,0v86.54H109.17Zm134.61,205H148V307.4a47.87,47.87,0,1,1,95.73,0V393.9ZM76.26,424.69V414.44h338.3v10.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    style: {
      fill: "#456E89"
    },
    d: "M291.56,270.92a10.25,10.25,0,0,0-10.25,10.26h0v82a10.25,10.25,0,0,0,10.25,10.25h61.49a10.25,10.25,0,0,0,10.25-10.25h0v-82a10.26,10.26,0,0,0-10.23-10.26Zm10.26,20.5h41v20.49h-41Zm41,61.49h-41v-20.5h41Z"
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHouseBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/houseBlue.b291f5d2.svg";
export { ForwardRef as ReactComponent };